<template>
    <div v-if="isShow" class="to-top" @click="toTop">
        <i class="el-icon-top"></i>
    </div>
</template>

<script>
export default {
    props: {
        visibilityHeight: {
            type: Number,
            default: 400
        },
    },
    computed: {
        isShow() {
            return this.scrollTop > this.visibilityHeight
        }
    },
    data() {
        return {
            scrollTop: 0,
        }
    },
    methods: {
        toTop() {
            // this.$emit("toTop");
            window.scrollTo(0, 0)
        },
        onScroll() {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        }
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll)
    },
    destroyed() {
        window.removeEventListener("scroll", this.onScroll)
    },
}
</script>

<style lang="scss" scoped></style>